export function roundOneDecimalValue(value) {
  const numberValue = Number(value);
  if (!Number.isFinite(numberValue)) {
    return value;
  }
  return Math.round(numberValue * 10) / 10;
}

export function formatOneDecimalValue(value) {
  const roundedValue = roundOneDecimalValue(value);
  if (!Number.isFinite(Number(roundedValue))) {
    return value;
  }
  return Number(roundedValue).toFixed(1);
}

export const roundIrrigationDepthValue = roundOneDecimalValue;
export const formatIrrigationDepthValue = formatOneDecimalValue;

export function formatIrrigationDepthUnit(unit, t = (text) => text) {
  const translatedUnit = t(unit);
  if (translatedUnit === 'in') {
    return 'in.';
  }
  return translatedUnit;
}

export function formatCropName(cropType) {
  if (!cropType) return null;
  return cropType
    .replace(/_/g, ' ')
    .replace(/\w\S*/g, (word) => (
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    ));
}
